import React, { useEffect, useState } from "react";
import AdminMenu from "./AdminMenu";
import axios from "axios";
//eslint-disable-next-line
import { Select, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import toast from "react-hot-toast";
import { server } from "../server";
import { IoCloseCircleSharp } from "react-icons/io5";
// import generateImageURL from "./generateImageURL";

const { Option } = Select;

const CreateCar = () => {
  const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [price, setprice] = useState("");
  const [fuelType, setfuelType] = useState("");
  const [transmission, settransmission] = useState("");
  const [engineSize, setengineSize] = useState("");
  const [mileage, setmileage] = useState("");
  const [safetyrating, setsafetyrating] = useState("");
  const [yom, setyom] = useState("");
  const [seater, setseater] = useState("");
  const [drive, setdrive] = useState("");
  const [horsepower, sethorsepower] = useState("");
  const [torque, settorque] = useState("");
  const [accelaration, setaccelaration] = useState("");
  const [size, setsize] = useState("");
  const [fuelTank, setfuelTank] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validateForm = () => {
    if (!brand.trim()) {
      toast.error("Car Brand is required");
      return false;
    }
    if (selectedImages.length === 0) {
      toast.error("Please Provide atleast one Image");
      return false;
    }
    if (!name.trim()) {
      toast.error("Car name is required");
      return false;
    }
    if (!price.trim()) {
      toast.error("Price is required");
      return false;
    }
    if (!fuelType.trim()) {
      toast.error("FuelType is required");
      return false;
    }
    if (!transmission.trim()) {
      toast.error("Transmission is required");
      return false;
    }
    if (!engineSize.trim()) {
      toast.error("Engine Size is required");
      return false;
    }
    if (!mileage.trim()) {
      toast.error("Mileage is required");
      return false;
    }

    if (!yom.trim()) {
      toast.error("Year of manufucture is required");
      return false;
    }

    if (!drive.trim()) {
      toast.error("Drive is required");
      return false;
    }
    if (!description.trim()) {
      toast.error("Description is required");
      return false;
    }

    return true;
  };

  const getAllCar = async () => {
    try {
      const { data } = await axios.get(`${server}/api/brand/getAll-brand`);
      if (data.success) {
        setBrands(data?.brands);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onImageInput = async (e) => {
    let files = Array.from(e.target.files);
    const toastId = toast.loading("Uploading Images. Please Wait... ");
    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "car-dellers-threedolts");
      formData.append("folder", "documents");

      try {
        const data = await fetch(
          // "https://api.cloudinary.com/v1_1/ddeia69sw/image/upload",
          "https://api.cloudinary.com/v1_1/dqv3ihfrx/image/upload",
          {
            method: "POST",
            body: formData,
          },
        );

        const uploadedImage = await data.json();

        const imageData = {
          url: uploadedImage.secure_url,
          public_id: uploadedImage.public_id,
        };
        setSelectedImages((prevImages) => [...prevImages, imageData]);
        toast.dismiss(toastId);
      } catch (error) {
        toast.dismiss(toastId);
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
        } else if (error.request) {
          console.error("Error request:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
        toast.error("Error uploading image");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      setLoading(true);
      const carData = new FormData();
      carData.append("name", name);
      carData.append("description", description);
      carData.append("brand", brand);
      carData.append("price", price);
      carData.append("fuelType", fuelType);
      carData.append("transmission", transmission);
      carData.append("engineSize", engineSize);
      carData.append("mileage", mileage);
      carData.append("safetyrating", safetyrating);
      carData.append("yom", yom);
      carData.append("seater", seater);
      carData.append("drive", drive);
      carData.append("horsepower", horsepower);
      carData.append("torque", torque);
      carData.append("accelaration", accelaration);
      carData.append("size", size);
      carData.append("fuelTank", fuelTank);
      selectedImages.forEach((image) => {
        carData.append("documents", JSON.stringify(image));
      });

      const { data } = await axios.post(
        `${server}/api/car/create-car`,
        carData,
      );

      if (data.success) {
        toast.success("Car Created Successfully");
        navigate("/dashboard/admin/cars");
      } else {
        toast.error("Error in Car creation");
      }
    } catch (err) {
      console.log(err);
      toast.error(
        "Too many Images Uploaded. Please reduce Number of Images, You can Edit the product Later.",
        { duration: 10000 },
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCar();
    window.scrollTo(0, 0);
  }, []);

  const deleteImage = async (index, image) => {
    const toastId = toast.loading("Deleting ...");
    await axios
      .delete(`${server}/api/car/delete-image`, {
        params: {
          image,
        },
      })
      .then((res) => {
        const updatedImages = [...selectedImages];
        updatedImages.splice(index, 1);
        setSelectedImages(updatedImages);

        console.log("updated images");

        toast.dismiss(toastId);
        toast.success("Image deleted");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error in deleting Image");
        toast.dismiss(toastId);
      });
  };

  return (
    <div className="container marginStyle">
      {!loading ? (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <AdminMenu />
            </div>
            <div className="col-md-9 my-3">
              <form method="post" enctype="multipart/form-data">
                <h1 className="text-center">Create Car</h1>
                <div className="m-1 add-car-container">
                  <div className="add-car-sub-container">
                    <div
                      style={{
                        border: "1px solid lightgray",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                      className="mb-3"
                    >
                      <label
                        htmlFor="carName"
                        className="form-label text-gray small-font"
                      >
                        <div>Upload Brand</div>
                        <div style={{ fontSize: "13px" }}>
                          (****Once a brand is allocated cannot be updated****)
                        </div>
                      </label>
                      <Select
                        bordered={false}
                        placeholder="Select A Brand"
                        size="large"
                        className="form-select"
                        onChange={(value) => {
                          setBrand(value);
                        }}
                      >
                        {brands?.map((c) => (
                          <Option key={c._id} value={c._id}>
                            {c.name}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    <div className="mb-3">
                      <input
                        type="text"
                        value={name}
                        placeholder="Enter car name"
                        className="form-control"
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <textarea
                        rows={3}
                        value={description}
                        placeholder="Enter car description"
                        className="form-control"
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={price}
                        placeholder="Enter car amount price"
                        className="form-control"
                        onChange={(e) => setprice(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <Select
                      bordered={false}
                      placeholder="Select car Drive"
                      size="large"
                      className="form-select mb-3"
                      onChange={(value) => {
                        setfuelType(value);
                      }}
                    >
                      <Option value="Petrol">Petrol</Option>
                      <Option value="Diesel">Diesel</Option>
                    </Select>
                    <Select
                      bordered={false}
                      placeholder="Select car Drive"
                      size="large"
                      className="form-select mb-3"
                      onChange={(value) => {
                        settransmission(value);
                      }}
                    >
                      <Option value="Automatic">Automatic</Option>
                      <Option value="Manual">Manual</Option>
                    </Select>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={engineSize}
                        placeholder="Enter car enginesize in cc"
                        className="form-control"
                        onChange={(e) => setengineSize(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={mileage}
                        placeholder="Enter car mileage in Kms"
                        className="form-control"
                        onChange={(e) => setmileage(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={yom}
                        placeholder="Year of manufucture"
                        className="form-control"
                        onChange={(e) => setyom(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="add-car-sub-container">
                    <div className="mb-3">
                      <input
                        type="number"
                        value={seater}
                        placeholder="Enter car seater"
                        className="form-control"
                        onChange={(e) => setseater(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <Select
                      bordered={false}
                      placeholder="Select car Drive"
                      size="large"
                      className="form-select mb-3"
                      onChange={(value) => {
                        setdrive(value);
                      }}
                    >
                      <Option value="2 WD">2 WD</Option>
                      <Option value="4 WD">4 WD</Option>
                    </Select>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={horsepower}
                        placeholder="Enter car horsepower"
                        className="form-control"
                        onChange={(e) => sethorsepower(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={torque}
                        placeholder="Enter car torque"
                        className="form-control"
                        onChange={(e) => settorque(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={accelaration}
                        placeholder="Enter car accelaration in seconds"
                        className="form-control"
                        onChange={(e) => setaccelaration(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={size}
                        placeholder="Enter Ground Clearance in mm"
                        className="form-control"
                        onChange={(e) => setsize(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={fuelTank}
                        placeholder="Enter car fueltank in litres"
                        className="form-control"
                        onChange={(e) => setfuelTank(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="number"
                        value={safetyrating}
                        placeholder="Enter car safetyrating"
                        className="form-control"
                        onChange={(e) => setsafetyrating(e.target.value)}
                        required
                        min={1}
                        inputmode="numeric"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        justifyContent: "center",
                        overflow: "hidden",
                        maxWidth: "100%",
                      }}
                    >
                      {selectedImages.map((image, index) => (
                        <div
                          key={index}
                          className="text-center"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={image.url}
                            alt={`car_image_${index}`}
                            className="img img-fluid"
                            style={{
                              maxWidth: "80px",
                              height: "auto",
                              borderRadius: "5px",
                              objectFit: "cover",
                            }}
                          />
                          <button
                            type="button"
                            className="remove-image-btn"
                            onClick={() => deleteImage(index, image.public_id)}
                            style={{
                              border: "none",
                              backgroundColor: "none",
                              background: "none",
                              position: "absolute",
                              top: "-2px",
                              right: "10px",
                              color: "red",
                            }}
                          >
                            <IoCloseCircleSharp
                              size={20}
                              style={{ color: "green" }}
                            />
                          </button>
                        </div>
                      ))}
                    </div>
                    <div className="image-upload mb-3">
                      <label className="upload-label col-md-12">
                        Upload Images
                        <input
                          type="file"
                          name="productPictures"
                          accept="image/*"
                          multiple
                          onChange={onImageInput}
                          hidden
                        />
                      </label>
                    </div>
                    <div className="mb-3">
                      <button
                        className="btn btn-success"
                        onClick={handleSubmit}
                        style={{ marginTop: "5px" }}
                      >
                        Create Car
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default CreateCar;
